export default "__VITE_ASSET__$iQxI4NI__"